import type { FaireBrandEntity } from "../../entity_types/brand";

export const starter_brand_hedley_bennett: FaireBrandEntity = {
  token: "starter_brand_hedley-bennett",
  type: "brand",
  name: "Hedley & Bennett",
  logoUrl: "",
  minimumOrderDollars: 150,
  rating: 4.8,
  location: "US",
  tags: ["starter-collections"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
